import { Action } from "redux"

import * as actions from "./actions"
import { transformIndicatorData } from "../../util/Indicator"
import { IIndicators } from "./index"

export const initialState: IIndicators = {
    indicatorId: 0,
    indicatorSchemeId: 0,
    indicators: [],
    isLoading: false,
    indicatorDetail: {
        indicator: {
            chartData: {
                datasets: [],
            },
            color: "",
            description: "",
            hasChart: false,
            id: 0,
            showLabels: true,
            title: "",
            url: "",
            value: 0,
        },
    },
}

const ACTION_HANDLERS: {
    [action: string]: (state: IIndicators, props: Action) => IIndicators
} = {
    [actions.REQUEST_INDICATORS]: (
        state,
        { indicatorId, indicatorSchemeId }: actions.RequestIndicators,
    ): IIndicators => ({
        ...state,
        isLoading: true,
        indicatorId,
        indicatorSchemeId,
    }),

    [actions.RECEIVE_INDICATORS]: (
        state,
        { indicators }: actions.ReceiveIndicators,
    ): IIndicators => ({
        ...state,
        indicators: indicators.map((indicator) =>
            transformIndicatorData(indicator, false),
        ),
        isLoading: false,
    }),

    [actions.REQUEST_INDICATOR]: (
        state,
        { indicatorId }: actions.RequestIndicator,
    ): IIndicators => ({
        ...state,
        isLoading: true,
        indicatorId,
    }),

    [actions.RECEIVE_INDICATOR]: (
        state,
        { indicator }: actions.ReceiveIndicator,
    ): IIndicators => ({
        ...state,
        indicatorDetail: {
            ...state.indicatorDetail,
            indicator: transformIndicatorData(indicator, true),
        },
        isLoading: false,
    }),

    [actions.RECEIVE_INDICATOR_ERROR]: (state): IIndicators => ({
        ...state,
        isLoading: false,
    }),
}

export default function reducer(
    state = initialState,
    action: Action,
): IIndicators {
    const handler: (state: IIndicators, action: Action) => IIndicators =
        ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
